export default __webpack_public_path__ + "static/media/2guns-accent.19764505.png";